module.exports = __webpack_public_path__ + "static/interactive-tool-image_vafseo-0bf35bd5df7832212bc5520cce7168bf.jpg";